import React, { useState } from 'react';
import FaqSection from 'components/FaqSection';
import GuideSection from 'components/GuideSection';
import Link from 'next/link';
import SideBar from './SideBar';
import {
    HeaderH2,
    HeaderH1,
    HeaderH3,
    Text,
    NextButton,
    ImageBlock
} from 'components/TextBlocks';
import { Button, Flex } from '@chakra-ui/react';

export const SC = ({ ...props }) => {
    const keyCss = {
        fontSize: '1rem',
        fontFamily: 'menlo, consolas, monospace',
        border: '1px solid #DDDDDD',
        borderRadius: '5px',
        boxShadow: '0 4px 8px -1px rgba(201,204,208,0.90)',
        backgroundColor: '#FFF',
        paddingTop: '4px',
        paddingBottom: '4px',
        paddingLeft: '7px',
        paddingRight: '6px'
    };
    return <span style={keyCss}>{props.children}</span>;
};

function Shortcuts(props) {
    let [isMac, setIsMac] = useState(true);
    let CMD = isMac ? '⌘' : 'Ctrl';

    return (
        <>
            <HeaderH1>Shortcuts</HeaderH1>
            <Text>
                Learning a few shortcuts can add up to a lot of saved time in
                the long run. Here are a couple of handy shortcuts to use.
                First, choose your platform:
            </Text>
            <Flex mb="32px">
                <Button
                    mr="12px"
                    bg={isMac ? '#0078FF' : 'gray.300'}
                    color={isMac ? '#FFF' : ''}
                    colo
                    onClick={() => setIsMac(true)}
                    transition="0.16s"
                    colorScheme={isMac ? 'blue' : 'gray'}
                >
                    macOS
                </Button>
                <Button
                    onClick={() => setIsMac(false)}
                    bg={!isMac ? '#0078FF' : 'gray.300'}
                    colorScheme={!isMac ? 'blue' : 'gray'}
                    color={!isMac ? '#FFF' : ''}
                    transition="0.16s"
                >
                    Windows
                </Button>
            </Flex>
            <HeaderH3>Overall</HeaderH3>
            <Text>
                Open tabExtend: <SC>{CMD}</SC> + <SC>T</SC>
                (shortcut to open a new tab)
            </Text>
            <Text>
                Change focus from searchbar(omnibar) to tabExtend:
                <SC>TAB</SC>
            </Text>
            <Text>
                Close tabExtend/current tab:
                <SC>{CMD}</SC> + <SC>W</SC>
            </Text>
            <Text>
                Creat new group: <SC>Ctrl</SC> + <SC>G</SC> (Can be changed in
                settings)
            </Text>
            <Text>
                Open workspace picker/search: <SC>{CMD}</SC> +{' '}
                {!isMac && <SC>⇧</SC>}
                {!isMac && ' + '}
                <SC>K</SC> (Can be changed in settings)
            </Text>
            <Text>
                Open bin: <SC>Ctrl</SC> + <SC>Z</SC> (Can be changed in
                settings)
            </Text>
            <HeaderH3>Workspaces and categories</HeaderH3>
            <Text>
                Open category modal: Click + hold on any category name for 0.4s
            </Text>
            <Text>
                Change selected category: <SC>1</SC>
                <SC>3</SC>
                <SC>2</SC>, etc
            </Text>
            <Text>
                Navigate workspaces(inside workspace picker): <SC>←</SC>
                <SC>↑</SC>
                <SC>→</SC>
                <SC>↓</SC>
            </Text>
            <Text>
                Switch to highlighted workspace: <SC>Enter</SC>
            </Text>
            <HeaderH3>Notes and items</HeaderH3>
            <Text>
                Selected multiple items: Hold <SC>⇧</SC>/<SC>Ctrl</SC> + Click
                item
            </Text>
            <Text>
                Create new note send to top: <SC>Enter</SC>+<SC>Enter</SC>
            </Text>
            <Text>
                Create new row inside note: <SC>⇧</SC>+<SC>Enter</SC>
            </Text>
            <Text>
                Create bullet point(• ): <SC>-</SC>+<SC>Space</SC>
            </Text>
            <Text>
                Create arrow(→): <SC>-</SC>+<SC>&gt;</SC>
            </Text>
            <Text>Convert note to to-do: /todo</Text>
            <Text>Complete To-do: /done</Text>
            <Text>
                Delete current selected note: <SC>⇧</SC>+<SC>Del</SC>
            </Text>
            <NextButton
                cta={'Create account'}
                textColor={'#565D65'}
                bg={'#EBECED'}
                page={'/guide/create-account'}
            />
        </>
    );
}

Shortcuts.Layout = SideBar;

export default Shortcuts;
